<template>
  <div class="shopping-cart">
    <PricingList v-if="shoppingCart.length" />
    <div v-else class="shopping-cart__empty">
      <div class="shopping-cart__icon-wrapper">
        <ShoppingCartIcon class="shopping-cart__cart-icon" />
        <h2 class="shopping-cart__empty-title">Your cart is empty</h2>
        <p class="shopping-cart__cta">To continue select a product</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShoppingCartIcon from '@/assets/icons/cart_icon.svg'
import PricingList from '@/components/cart/pricing-list/PricingList.vue'

export default {
  name: 'ShoppingCartList',
  components: {
    PricingList,
    ShoppingCartIcon: { ...ShoppingCartIcon, name: 'ShoppingCartIcon' },
  },
  computed: {
    ...mapGetters({
      shoppingCart: 'shoppingCart/getShoppingCart',
    }),
  },
}
</script>

<style lang="scss">
.shopping-cart {
  color: var(--white);
  font-family: var(--font-regular);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  text-align: center;
  height: 100%;
  padding: 20px;
  @include mobile {
    padding: unset;
  }
  &__empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    text-align: center;
    height: 100%;
    width: 100%;
  }
  &__icon-wrapper {
    display: none;
    @include mobile {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      text-align: center;
    }
  }
  &__cart-icon {
    margin: 0 25px 15px 0;
  }
  &__empty-title {
    font-family: var(--font-bold);
    font-size: rem(40);
    line-height: 52px;
    width: 100%;
    margin: 0;
  }
  &__cta {
    color: var(--light-blue-gray);
    font-size: rem(18);
    line-height: 22px;
    margin: 5px auto;
    padding: 0;
    width: 100%;
    width: 275px;
  }
}
</style>
